var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRightEndArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.002 11.062a.938.938 0 0 0 1.487.759l7.202-5.215a.749.749 0 0 0 0-1.212L8.492.179a.94.94 0 0 0-1.487.76v3.096L1.48.17A.941.941 0 0 0 0 .942v10.116a.946.946 0 0 0 1.484.772l5.518-3.865v3.097Zm0-4.928-5.5 3.85V2.016l5.5 3.85v.268ZM13.972 6l-5.47 3.962V2.038L13.971 6Z"
})));
export default SvgRightEndArrowIcon;